<script setup lang="ts">
  import type { PermissionSubject } from '@/features/FormBuilder';
  import { useMatrixFillLabContext } from '../../model/useMatrixFillLab';
  import FieldRef from './FieldRef.vue';
  import LabSection from './LabSection.vue';

  const lab = useMatrixFillLabContext();

  function names(ids: number[], source: PermissionSubject[]): string {
    const found = source.filter((item) => ids.includes(item.id)).map((item) => item.name);
    return found.length > 0 ? found.join(', ') : 'nenhum';
  }
</script>

<template>
  <LabSection
    title="Permissões resolvidas"
    nested
    open
    :badge="`${lab.grantResolutions.value.filter((grant) => grant.allowed).length}/${lab.grantResolutions.value.length} liberadas`"
    hint="Para cada campo com permissão, o compilador cruza os cargos e atividades de quem preenche com os da concessão. Campo sem permissão segue o padrão aberto ou fechado."
    data-testid="lab-permission-trace"
  >
    <p
      v-if="lab.grantResolutions.value.length === 0"
      class="italic text-[var(--color-gray-05)]"
    >
      Nenhuma permissão em uso: todos os campos seguem o padrão "{{ lab.defaultAccess.value === 'open' ? 'aberto' : 'fechado' }}".
    </p>
    <ul
      v-else
      class="flex flex-col gap-1.5"
    >
      <li
        v-for="grant in lab.grantResolutions.value"
        :key="grant.fieldId"
        class="rounded-md border border-[var(--color-gray-02)] bg-[var(--color-white-01)] p-2"
      >
        <div class="flex items-center gap-2">
          <span
            class="shrink-0 rounded-full px-1.5 py-0.5 text-[10px] font-semibold"
            :class="grant.allowed ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'"
          >
            {{ grant.allowed ? 'PODE' : 'NÃO PODE' }}
          </span>
          <FieldRef :id="grant.fieldId" />
        </div>
        <p class="mt-1 text-[var(--color-gray-06)]">
          Cargos: {{ names(grant.positionIds, lab.subjects.positions.value) }}
        </p>
        <p class="text-[var(--color-gray-06)]">
          Atividades: {{ names(grant.functionalActivityIds, lab.subjects.functionalActivities.value) }}
        </p>
      </li>
    </ul>
  </LabSection>
</template>
